import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { firstValueFrom } from 'rxjs';
import { UserProfileService } from 'src/app/modules/user-profile/features/user-profile-page/services/user-profile-page.service';

export const noAuthGuard: CanActivateFn = async () => {
  const authenticationService = inject(AuthenticationService);
  const userProfileService = inject(UserProfileService);
  const router = inject(Router);

  if (await authenticationService.isAuthenticated()) {
    const res: any = await firstValueFrom(
      userProfileService.getCurrentUserProfileInfo()
    );

    let shipmentAndPickupEligible = false;
    if (res.success && res.data) {
      shipmentAndPickupEligible =
        res.data.customer?.shipmentEligible &&
        res.data.customer?.pickupEligible;
    }

    if (!shipmentAndPickupEligible) {
      router.navigateByUrl('/company/accounts');
    } else {
      router.navigateByUrl(authenticationService.redirectUrl);
    }
    return false;
  } else {
    return true;
  }
};
